// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__16N5s","loginButton":"app_loginButton__2fQNo"};